﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SagaTriggerActionTypes;
(function (SagaTriggerActionTypes) {
    SagaTriggerActionTypes["TRIGGER_RENEW_TOKEN_SAGA"] = "TRIGGER_RENEW_TOKEN_SAGA";
    SagaTriggerActionTypes["TRIGGER_LOGOUT_SAGA"] = "TRIGGER_AFTER_LOGOUT_SAGA";
    SagaTriggerActionTypes["TRIGGER_UPDATE_ORGANIZATIONS"] = "TRIGGER_UPDATE_ORGANIZATIONS";
})(SagaTriggerActionTypes = exports.SagaTriggerActionTypes || (exports.SagaTriggerActionTypes = {}));
exports.actionCreators = {
    triggerRenewTokenSaga: (action) => ({
        type: SagaTriggerActionTypes.TRIGGER_RENEW_TOKEN_SAGA,
        payload: action
    }),
    triggerLogoutSaga: () => ({
        type: SagaTriggerActionTypes.TRIGGER_LOGOUT_SAGA
    }),
    triggerUpdateOrganizationsSaga: () => ({
        type: SagaTriggerActionTypes.TRIGGER_UPDATE_ORGANIZATIONS
    })
};
//# sourceMappingURL=sagaActions.js.map